import { render, staticRenderFns } from "./VideoPlyer.vue?vue&type=template&id=174e9e6c"
import script from "./VideoPlyer.vue?vue&type=script&lang=js"
export * from "./VideoPlyer.vue?vue&type=script&lang=js"
import style0 from "./VideoPlyer.vue?vue&type=style&index=0&id=174e9e6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports